import { TextareaHTMLAttributes } from 'react';
import styles from './styles.module.scss';

type Props = {
  id?: string;
  value?: TextareaHTMLAttributes<HTMLTextAreaElement>['value'];
  defaultValue?: TextareaHTMLAttributes<HTMLTextAreaElement>['defaultValue'];
  placeholder?: TextareaHTMLAttributes<HTMLTextAreaElement>['placeholder'];
  rows?: TextareaHTMLAttributes<HTMLTextAreaElement>['rows'];
  onChange?: TextareaHTMLAttributes<HTMLTextAreaElement>['onChange'];
  onBlur?: TextareaHTMLAttributes<HTMLTextAreaElement>['onBlur'];
  error?: boolean;
};

export const TextArea: React.FC<Props> = ({
  id,
  value,
  defaultValue,
  placeholder,
  rows = 4,
  onChange,
  onBlur,
  error,
}) => (
  <textarea
    className={`${styles.textAreaElement} ${error ? styles.error : ''}`}
    id={id}
    value={value}
    defaultValue={defaultValue}
    placeholder={placeholder}
    rows={rows}
    onChange={onChange}
    onBlur={onBlur}
  />
);
